<template>
  <div class="invoice-history-img__main scroll-touch">
    <div v-for="(item, index) in goodsImgList" :key="index"
         :class="['invoice-history-img__main-item', index===0?'first':'']" @click="showBigImg(index)">
      <img :src="item">
    </div>
    <goods-preview :defaultIndex="defaultImgIndx" :images="allImages" :isShow="isShowBigImage"
                   @close="isShowBigImage=false"></goods-preview>
  </div>
</template>

<script>
import GoodsPreview from 'components/common/GoodsPreview';

export default {
  name: 'index',
  components: {
    GoodsPreview,
  },
  props: {
    goodsImgList: Array,
  },
  data() {
    return {
      allImages: this.goodsImgList,
      isShowBigImage: false,
      defaultImgIndx: 0,
    };
  },
  methods: {
    showBigImg(index) {
      this.defaultImgIndx = index;
      this.allImages = this.goodsImgList;
      this.hasAnyAction = true;
      this.isShowBigImage = true;
    },
  },
};
</script>

<style lang="scss">

.first {
  margin-left: 0 !important;
}

.invoice-history-img {
  &__main {
    display: flex;

    &-item {
      width: 98px;
      height: 98px;
      margin: 0 10px;
      border-radius: 5px;
      border: 1px solid rgba(234, 234, 234, 1);

      img {
        display: block;
        width: 98px;
        height: 98px;
      }
    }
  }
}
</style>
